
















































import Dialog from '@/types/Dialog.interface'
import Vue from 'vue'
import AdminConfirmForm from '@/components/AdminConfirmForm.vue'
export default Vue.extend({
    components: { AdminConfirmForm },
    props: {
        id: {
            type: Number,
            default: null
        }
    },
    computed: {
        dialog(): Dialog {
            return this.$store.getters.dialogConfirm[this.id]
        },
        support(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is a support user
            return window.getProps(role, ['name']) === 'Support'
        }
    },
    methods: {
        close(bool: boolean): void {
            //  If a 'callback' is set, we always use it
            if (this.dialog.callback) this.dialog.callback(bool)

            //  Only execute a link if bool is true
            if (bool && this.dialog.link) this.$router.push(this.dialog.link)

            //  Always close the dialog
            this.$store.dispatch('dialogClose', 'CONFIRM')
        }
    }
})
